import { createRouter, createWebHistory } from 'vue-router'
import StaticsView from '../views/StaticsView.vue'
import LoginView from '../views/LoginView.vue'
import TFAView from '../views/TFAView.vue'
import RegisterView from '../views/RegisterView.vue'
import { beforeEach } from './guards'

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
    meta: { requiresAuth: false }
  },
  {
    path: '/2fa',
    name: '2fa',
    component: TFAView,
    meta: { requiresAuth: false }
  },
  {
    path:'/register',
    name: 'register',
    component: RegisterView,
    meta: { requiresAuth: false }
  },
  {
    path: '/statics',
    name: 'statics',
    component: StaticsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/stores',
    name: 'stores',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Stores/IndexView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path:'/stores/:id',
    name: 'store',
    component: () => import('../views/Stores/StoreView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/plans',
    name: 'plans',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/PlansView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path:'/config',
    name: 'config',
    component: ()=>import('../views/ConfigView.vue'),
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach( beforeEach );

export default router
